module.exports = __webpack_public_path__ + "static/media/poster.8ba114e0.png";